import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const sharedClasses = `
    relative group overflow-hidden rounded-sm font-body font-bold text-white 
    bg-gradient-to-r from-terra-600 via-terra-500 to-terra-400
    px-8 py-4 shadow-[0_0_20px_rgba(194,112,62,0.3)]
    transition-all duration-300 hover:shadow-[0_0_30px_rgba(194,112,62,0.5)]
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const inner = <>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-30" />
      <span className="relative flex items-center justify-center gap-2 text-lg tracking-wide" data-id="element-31">
        {children}
      </span>
    </>;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`inline-block text-center no-underline ${sharedClasses}`} data-id="element-32">
        {inner}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={sharedClasses} data-id="element-33">
      {inner}
    </motion.button>;
}